import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';
import * as Enum from '../utils/enums'


@Component({
  selector: 'app-filiera-modal',
  templateUrl: './filiera-modal.component.html',
  styleUrls: ['./filiera-modal.component.css']
})
export class FilieraModalComponent implements OnInit {

  dettagli: any[]  // table data source
  DTTM //export enum for html of modal

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) { }

  ngOnInit() {

    //Configurazione del modale di dettaglio per esecutore, persona e mezzo
    let arrayData = []
    if (this.config.data.type == Enum.DATA_TABLE_TYPE_ENUM.PERSONA) {
      this.DTTM = Enum.DATA_TABLE_TYPE_ENUM.PERSONA
      arrayData = this.config.data.data
    }
    else if (this.config.data.type == Enum.DATA_TABLE_TYPE_ENUM.MEZZO) {
      this.DTTM = Enum.DATA_TABLE_TYPE_ENUM.MEZZO
      arrayData = this.config.data.data
    }
    else if (this.config.data.type == Enum.DATA_TABLE_TYPE_ENUM.ESECUTORE) {
      this.DTTM = Enum.DATA_TABLE_TYPE_ENUM.ESECUTORE
      arrayData.push(this.config.data.data) //esecutore è un oggetto e vuole un array
    }
    else if (this.config.data.type == Enum.DATA_TABLE_TYPE_ENUM.AGGIUDICATARIO_FILIERA) {
      this.DTTM = Enum.DATA_TABLE_TYPE_ENUM.AGGIUDICATARIO_FILIERA
      arrayData.push(this.config.data.data) //aggiudicatario è un oggetto e vuole un array
    }

    this.dettagli = arrayData
  }

}
